<template>
  <TBreadcrumb :items="TBreadcrumbPropsItemsInstance" />
</template>

<script setup lang="ts">
import { useMenuBreadcrumb } from '../composables/useMenuBreadcrumb'

const { TBreadcrumbPropsItemsInstance } = await useMenuBreadcrumb()
</script>
